"use client";

import * as React from "react";

import useEmblaCarousel, {
} from "embla-carousel-react";

import { cn } from "@/shared-web.ui/util.cn";

type UseCarouselParameters = Parameters<typeof useEmblaCarousel>;
type CarouselOptions = UseCarouselParameters[0];
type CarouselPlugin = UseCarouselParameters[1];

type CarouselProps = {
  carouselOpts?: CarouselOptions;
  carouselPlugins?: CarouselPlugin;
};

interface ProductCardRowProps extends CarouselProps {
  children: React.ReactNode;
  flexClassName?: string;
}
const ProductCardRow = React.forwardRef<
  HTMLDivElement,
  ProductCardRowProps & React.HTMLAttributes<HTMLDivElement>
>((props, ref) => {
  const {
    children,
    className,
    carouselOpts,
    carouselPlugins,
    flexClassName,
    ...divProps
  } = props;

  // -> init carousel instance
  const [carouselMainRef, carouselMainApi] = useEmblaCarousel(
    {
      ...carouselOpts,
    },
    carouselPlugins,
  );

  return (
    <div
      aria-roledescription="carousel"
      className={cn(
        "relative w-full",
        className,
      )}
      ref={ref}
      role="region"
      {...divProps}
    >
      <div
        className="overflow-hidden"
        ref={carouselMainRef}
      >
        <div
          className={cn(
            "flex py-4",
            flexClassName,
          )}
          ref={carouselMainRef}
        >
          {children}
        </div>
      </div>
    </div>
  );
});
ProductCardRow.displayName = "ProductCardRow";

export {
  type CarouselProps,
  ProductCardRow,
  type ProductCardRowProps,
};
